<div class="visor">
    <div class="objViewer" #objViewer></div>
</div>
